import React from 'react'
import { message, Breadcrumb } from 'antd';
import { connect } from "react-redux";
import actionWays from '../../../redux/actions.js';
import Top from '../Top'
import Footer from '../Footer.js'
import { getAttachmentList, getAttachmentDetail } from '../../../utils/api/index.js'
import './dataDownload.scss'
class DataDownload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabData: [],
            loading: false,
            rawHTML: '',
            rightTitle: '',
            downLoadList: [],
        }
    }
    componentDidMount() {
        this.getPageAll()
    }
    getPageLeft = async () => {
        let projectList = await getAttachmentList({ n: 10000 })
        console.log(projectList);
        if (projectList.code === 0) {
            const tabData = projectList.data
            this.getPageRight(tabData[0].id)
            this.setState({
                tabData: tabData,
            });
        } else {
            message.error(projectList.message)
        }
    }
    getPageRight = async (id) => {
        let projectList = await getAttachmentDetail({ id: id })
        console.log(projectList);
        if (projectList.code === 0) {
            const rawHTML = projectList.data.content
            const rightTitle = projectList.data.title
            const downLoadList = projectList.data.attachmentUrlList
            this.setState({
                rawHTML: rawHTML,
                rightTitle: rightTitle,
                downLoadList: downLoadList,
                loading: true,
            }, () => {
                const rightBox = document.getElementsByClassName('dataDownload_right')
                const images = rightBox[0].querySelectorAll('img');
                images.forEach((img) => {
                    // 为图片添加点击事件
                    img.addEventListener('click', () => {
                        // 在新页面中打开图片
                        window.open(img.src + "?download=0", '_blank');
                    });
                });
            });
        } else {
            message.error(projectList.message)
        }
    }
    getPageAll = () => {
        tapOnce(this.getPageLeft, null, 500)
    }
    downloadFile = (path) => {
        const a = document.createElement('a');
        a.href = path;
        a.download = path;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    render() {
        const { tabData, rawHTML, rightTitle, downLoadList, loading } = this.state;
        return (
            <div id={'dataDownload'} style={{ background: '#fff' }}>
                <Top />
                {loading ? <div>
                    <div className="col-lg-2"></div>
                    <div className="col-lg-8">
                        <div style={{ paddingLeft: '7px', margin: '1em 0' }}>
                            <Breadcrumb separator=">">
                                <Breadcrumb.Item>首页</Breadcrumb.Item>
                                <Breadcrumb.Item>附件管理</Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                        <div className='dataDownload_box'>
                            <div className='dataDownload_left'>
                                <p className='ddLeft_top'>资料下载</p>
                                <div className='ddLeft_body'>
                                    <ul>
                                        {tabData.map(item => (
                                            <li key={item.id} title={item.title} onClick={() => {
                                                this.getPageRight(item.id)
                                            }}>{item.title}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className='dataDownload_middle'></div>
                            <div className='dataDownload_right'>
                                <p className='ddRight_top'>{rightTitle}</p>
                                <div className='ddRight_middle'>
                                    <div dangerouslySetInnerHTML={{ __html: rawHTML }}></div>
                                </div>
                                {downLoadList?.length > 0 ? <div className='ddRight_btm'>
                                    <a onClick={() => {
                                        downLoadList.map((path) => {
                                            this.downloadFile(path)
                                        })
                                    }}>下载附件</a>
                                </div> : ''}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-2"></div>
                    <Footer />
                </div> : ''}
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo,
    }
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(DataDownload)
